export const URL_API =
   "/api"
  // "https://localhost:5021/api";
  //"https://feedbackradar-back-test.azurewebsites.net/api";
export const URL_BASIC =
    "/"
  // "https://localhost:5021/";
  //"https://feedbackradar-back-test.azurewebsites.net/";
